import PaddleCheckoutButton from "@litonarefin/components/PaddleCheckoutButton/PaddleCheckoutButton";
// import { useSearchParams } from "next/navigation";
// import { useEffect } from "react";

const BundlePaddleCheckout = ({ attributes }) => {
  // const searchParams = useSearchParams();
  // const plan_id = searchParams.get("plan_id");

  /**
   * Auto click in new tab
   */
  // useEffect(() => {
  //   const triggerBtn = document.querySelector(
  //     `[data-plan-id="${attributes?.selectedVariationId}"]`
  //   );
  //   if (!triggerBtn) return;

  //   let timeoutId;
  //   if (plan_id === triggerBtn.getAttribute("data-plan-id")) {
  //     timeoutId = setTimeout(() => {
  //       triggerBtn.click();
  //     }, 100);
  //   }

  //   return () => clearTimeout(timeoutId);
  // }, [plan_id]);

  return <PaddleCheckoutButton attributes={attributes} />;
};

export default BundlePaddleCheckout;
